import axios from 'axios';

export const BACKEND_URL = 'https://strapi.silabor.it';
const API_URL = BACKEND_URL + '/api';